import { useCallback, useRef } from "react";

// Ensures only the most recent async request can update UI state.
export default function useLatestRequest() {
  const latestRequestIdRef = useRef(0);

  const runLatest = useCallback(async (requestFn, handlers = {}) => {
    const requestId = ++latestRequestIdRef.current;
    const { onSuccess, onError, onFinally } = handlers;

    try {
      const result = await requestFn();
      if (requestId !== latestRequestIdRef.current) return { ignored: true, result: undefined };
      if (onSuccess) onSuccess(result);
      return { ignored: false, result };
    } catch (error) {
      if (requestId !== latestRequestIdRef.current) return { ignored: true, error };
      if (onError) onError(error);
      return { ignored: false, error };
    } finally {
      if (requestId === latestRequestIdRef.current && onFinally) {
        onFinally();
      }
    }
  }, []);

  return runLatest;
}
